import Blue from '~/core'

new Blue({
  name: 'Landing Hero Animation',
  selector: '.landing-hero--animated',
  setup(hero) {
    const lottieElement = hero.querySelector('lottie-player.landing-hero__image')
    if (!lottieElement) return

    const lottie = lottieElement.getLottie()

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.5) {
            lottie.play()
            return
          }

          lottie.pause()
        })
      },
      {
        threshold: 1,
        rootMargin: '-50px',
      },
    )

    observer.observe(hero)
  },
})
